import type { Secrets } from 'Secrets'

export default {
  meetingHost: 'https://embed.webby.app'
} satisfies Secrets
